import React from 'react';
import { Table } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { SkillLevelLabel } from '../../pages/Skills/common/SkillLevelLabel';
import { SkillGapRow, SkillGapStatus } from './logic';
import './skillGap.css';

type Props = {
  rows: readonly SkillGapRow[];
};

// The level badge keeps its own scale colour; the gap is shown as a ring around
// it so "how far off target" reads at a glance without losing the level colour.
const gapClassName: Record<SkillGapStatus, string> = {
  met: 'skill-gap-met',
  below: 'skill-gap-below',
  missing: 'skill-gap-missing',
  none: '',
};

export const SkillGapTable: React.FC<Props> = ({ rows }) => {
  const t = useNamespacedTranslation('skills.targetProfile');

  return (
    <Table responsive={true} className="mb-0">
      <thead>
        <tr>
          <th>{t('skillColumn')}</th>
          <th className="text-center">{t('currentLevelColumn')}</th>
          <th className="text-center">{t('requiredLevelColumn')}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td className="align-middle">{row.skillName}</td>
            <td>
              <div className="d-flex justify-content-center">
                <SkillLevelLabel
                  value={row.currentLevel}
                  className={gapClassName[row.status]}
                  title={
                    row.status === 'none' ? undefined : t(`gap.${row.status}`)
                  }
                />
              </div>
            </td>
            <td>
              <div className="d-flex justify-content-center">
                <SkillLevelLabel value={row.targetLevel} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
